import {Device} from '@fantasmagames/core/src/device/Device';
import {SoundManager} from '@fantasmagames/slot/src/sound/SoundManager';

export class GameMobileSoundManager extends SoundManager {
	protected _allEffects: PIXI.sound.Sound;
	protected _allEffectsConfig: any;

	public init(device: Device): void {
		this._allEffects = this.loader.getSound('resources/mobileSounds/all.mp3');
		this._allEffectsConfig = this.loader.getMobileSoundConfig();

		this._effects.allSound = this._allEffects;
		super.init(device);
	}

	public getSoundLength(id: string): number {
		if (this._allEffects.sprites.hasOwnProperty(id)) {
			return this._allEffects.sprites[id].duration;
		}

		if (this._effects[id]) {
			return this._effects[id].duration;
		}
	}

	public getMusicLength(id: string): number {
		return this._music[id].duration;
	}

	public getVoiceLength(id: string): number {
		return this._allEffects.sprites[id].duration;
	}

	protected initVolumes(): void {

	}

	protected initEffects(): void {
		super.initEffects();
		const curConfig: any = this._allEffectsConfig.spritemap;

		this._allEffects.addSprites('buttonClick', {start: curConfig.btn_general.start, end: curConfig.btn_general.end});
		this._allEffects.addSprites('spinBtnStart', {start: curConfig.btn_spin_start.start, end: curConfig.btn_spin_start.end});

		this._allEffects.addSprites('gameIntro', {start: curConfig.trans_game_intro.start, end: curConfig.trans_game_intro.end});

		this._allEffects.addSprites('reelsFallOut', {start: curConfig.reels_fall_out.start, end: curConfig.reels_fall_out.end});
		this._allEffects.addSprites('reelsFallIn', {start: curConfig.reels_fall_in.start, end: curConfig.reels_fall_in.end});
		this._allEffects.addSprites('reelsFallIn3sec', {start: curConfig.reels_fall_in_3sec.start, end: curConfig.reels_fall_in_3sec.end});
		this._allEffects.addSprites('reelsRemove', {start: curConfig.reels_remove.start, end: curConfig.reels_remove.end});

		this._allEffects.addSprites('winLineL', {start: curConfig.win_indicate_lr.start, end: curConfig.win_indicate_lr.end});
		this._allEffects.addSprites('winLineR', {start: curConfig.win_indicate_rl.start, end: curConfig.win_indicate_rl.end});
		this._allEffects.addSprites('winCountup', {start: curConfig.win_countup.start, end: curConfig.win_countup.end});
		this._allEffects.addSprites('winNormal', {start: curConfig.win_normal.start, end: curConfig.win_normal.end});
		this._allEffects.addSprites('winNice', {start: curConfig.win_nice.start, end: curConfig.win_nice.end});
		this._allEffects.addSprites('winExcellent', {start: curConfig.win_excellent.start, end: curConfig.win_excellent.end});
		this._allEffects.addSprites('winRetrigger', {start: curConfig.win_retrigger.start, end: curConfig.win_retrigger.end});

		this._allEffects.addSprites('bigwinBuildup', {start: curConfig.win_bigwin_buildup.start, end: curConfig.win_bigwin_buildup.end});
		// this._allEffects.addSprites('bigwinLoop', {start: curConfig.win_bigwin_loop.start, end: curConfig.win_bigwin_loop.end});
		this._allEffects.addSprites('bigwinEnd', {start: curConfig.win_bigwin_end.start, end: curConfig.win_bigwin_end.end});
		this._allEffects.addSprites('bigwinThreshold', {start: curConfig.win_bigwin_threshold.start, end: curConfig.win_bigwin_threshold.end});

		this._allEffects.addSprites('multCollectFly', {start: curConfig.mult_collect_fly.start, end: curConfig.mult_collect_fly.end});
		this._allEffects.addSprites('multCollectHit', {start: curConfig.mult_collect_hit.start, end: curConfig.mult_collect_hit.end});
		this._allEffects.addSprites('multUpdate', {start: curConfig.mult_update.start, end: curConfig.mult_update.end});
		this._allEffects.addSprites('multUpdateFs', {start: curConfig.mult_update_fs.start, end: curConfig.mult_update_fs.end});
		this._allEffects.addSprites('multWildBreak', {start: curConfig.mult_wildbreak.start, end: curConfig.mult_wildbreak.end});
		this._allEffects.addSprites('multWin', {start: curConfig.mult_win.start, end: curConfig.mult_win.end});

		this._allEffects.addSprites('respinAttention', {start: curConfig.atn_respin.start, end: curConfig.atn_respin.end});
		this._allEffects.addSprites('respinActivate', {start: curConfig.rsp_activate.start, end: curConfig.rsp_activate.end});
		this._allEffects.addSprites('respinMove', {start: curConfig.rsp_move.start, end: curConfig.rsp_move.end});
		this._allEffects.addSprites('respinHit1', {start: curConfig.rsp_hit01.start, end: curConfig.rsp_hit01.end});
		this._allEffects.addSprites('respinHit2', {start: curConfig.rsp_hit02.start, end: curConfig.rsp_hit02.end});
		this._allEffects.addSprites('respinHit3', {start: curConfig.rsp_hit03.start, end: curConfig.rsp_hit03.end});
		this._allEffects.addSprites('respinEnd', {start: curConfig.rsp_end.start, end: curConfig.rsp_end.end});

		this._allEffects.addSprites('scatterAttention1', {start: curConfig.atn_scatter_1.start, end: curConfig.atn_scatter_1.end});
		this._allEffects.addSprites('scatterAttention2', {start: curConfig.atn_scatter_2.start, end: curConfig.atn_scatter_2.end});
		this._allEffects.addSprites('scatterAttention3', {start: curConfig.atn_scatter_3.start, end: curConfig.atn_scatter_3.end});

		this._allEffects.addSprites('freeSpinsIntro', {start: curConfig.trans_fs_intro.start, end: curConfig.trans_fs_intro.end});
		this._allEffects.addSprites('freeSpinsOutro', {start: curConfig.trans_fs_outro.start, end: curConfig.trans_fs_outro.end});

		this._allEffects.addSprites('spinBtnQuickStop', {start: curConfig.btn_spin_stop.start, end: curConfig.btn_spin_stop.end});
		this._allEffects.addSprites('multCollectIndicator', {start: curConfig.mult_collect_indicator.start, end: curConfig.mult_collect_indicator.end});

		this._effects.bigwinLoop = this.loader.getSound('resources/sounds/music/win_bigwin_loop.mp3');
	}

	protected initMusic(): void {
		super.initMusic();

		this._music.mainMusic1 = this.loader.getSound('resources/sounds/music/music_main_1.mp3');
		this._music.mainMusic2 = this.loader.getSound('resources/sounds/music/music_main_2.mp3');
		this._music.mainMusic3 = this.loader.getSound('resources/sounds/music/music_main_3.mp3');
		this._music.freeSpinsMusic = this.loader.getSound('resources/sounds/music/music_fs.mp3');
	}

	protected initVoice(): void {
		super.initVoice();
	}
}



// WEBPACK FOOTER //
// ./src/sound/GameMobileSoundManager.ts